import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { map } from 'rxjs/operators';

import {
  Statistics,
  DateRange,
  makeStatistics,
  StatisticsType,
  JumpstoryStatistics,
} from '../models';

@Injectable()
export class EmailService {
  constructor(
    private readonly http: HttpClient,
    @Inject('emailBaseUrl') private emailBaseUrl: string,
  ) {}

  private getApiUrl(path: string, accountId: string) {
    const accountPath = accountId ? `accounts/${accountId}/` : '';

    return `${this.emailBaseUrl}backoffice/statistics/${accountPath}${path}`;
  }

  private getParams({ from, to }: DateRange) {
    return {
      from: from.toString(),
      to: to.toString(),
    };
  }

  getStatistics(dateRange: DateRange, accountId: string) {
    return this.http
      .get(this.getApiUrl('', accountId), { params: this.getParams(dateRange) })
      .pipe(
        map((statistics: Statistics | Statistics[]) =>
          Array.isArray(statistics)
            ? makeStatistics(statistics[0])
            : makeStatistics(statistics),
        ),
      );
  }

  getStatisticsOverTime(timeSpan: number[], accountId: string) {
    return this.http.post<Statistics[]>(
      this.getApiUrl('', accountId),
      timeSpan,
    );
  }

  getDomainStatistics(dateRange: DateRange, accountId: string) {
    return this.http.get<Statistics[]>(this.getApiUrl('domains', accountId), {
      params: this.getParams(dateRange),
    });
  }

  getSendingsStatistics(dateRange: DateRange, accountId: string) {
    return this.http.get<Statistics[]>(this.getApiUrl('sendings', accountId), {
      params: this.getParams(dateRange),
    });
  }

  fetchJumpstoryStatistics(timeSpans: DateRange) {
    return this.http.get<JumpstoryStatistics[]>(
      this.getApiUrl('jumpstory', ''),
      { params: this.getParams(timeSpans) },
    );
  }

  fetchJumpstoryStatisticsByAccount(accountId: string, timeSpans: DateRange) {
    return this.http.get<JumpstoryStatistics[]>(
      this.getApiUrl(`jumpstory/${accountId}`, ''),
      { params: this.getParams(timeSpans) },
    );
  }

  getJumpstoryStatisticsCSV(accountId: string, dateRange: DateRange) {
    const headers = new HttpHeaders({ Accept: 'text/csv' });

    return this.http.get(this.getApiUrl(`jumpstory/${accountId}`, ''), {
      params: this.getParams(dateRange),
      headers,
      responseType: 'arraybuffer',
    });
  }

  getStatisticsCSV(
    type: StatisticsType,
    accountId: string,
    dateRange: DateRange,
  ) {
    const headers = new HttpHeaders({ Accept: 'text/csv' });

    return this.http.get(this.getApiUrl(type, accountId), {
      params: this.getParams(dateRange),
      headers,
      responseType: 'arraybuffer',
    });
  }
}
